import React from 'react';
import { LoadingFullScreenDialogStyled } from './styles';

const LoadingFullScreenDialog = ({ loading = false }) => {
  if (!loading) return null;

  return (
    <LoadingFullScreenDialogStyled>
      <div className="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </LoadingFullScreenDialogStyled>
  );
};

export default React.memo(LoadingFullScreenDialog);
